import { Button, Typography} from "@arco-design/web-react";
import {useLocation, useNavigate} from "react-router-dom";
import { routes } from "../routes/routes";
import { ReactNode, } from "react";

import { Logo } from "../components/Logo";
import { Grid } from "@arco-design/web-react";

import { getBoxBackgroundColor, getColorAccent1, getTextColor } from "../utils/cssVariables";
import { IconEmail } from "@arco-design/web-react/icon";
import Paragraph from "@arco-design/web-react/es/Typography/paragraph";
import axios from "axios";
import { endpoints } from "../api/endpoints";
import { getAuth } from "firebase/auth";
import { useTranslation } from "react-i18next";
import { LanguageSelect } from "../components/LanguageSelect/LanguageSelect";
import { getAuthLogoType } from "../theme";

const Row = Grid.Row;

export const ConfirmEmail = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const email = params.get("email");
    axios.post(
        endpoints.confirmedEmail,
        {
            email: email,
        }
    );
    const handleLoginRedirect = async () => {
        const user = getAuth();
        const idToken = await user.currentUser?.getIdToken();
        if(idToken) {
            await axios.get(endpoints.whoami, {
                headers: { Authorization: `Bearer ${idToken}` },
            });
            navigate(routes.profile);
        } else {
            navigate(routes.profile);
        }
    };

    const PageWrapper = ({children}: {children: ReactNode}) => (
        <div
            style={{
                justifyContent: "center",
                backgroundColor: getBoxBackgroundColor(),
                maxWidth: 480,
                width: "calc(100% - 40px)",
                margin: "20px auto",
                padding: "20px",
                borderRadius: 8,
            }}
        >
            <Logo variant="auth" style={{ marginTop: 10 }} type={getAuthLogoType()} />
            <div style={{
                display: 'flex',
                justifyContent: "center",
                paddingTop: 12,
                margin: "0 auto",
            }}><LanguageSelect color={getTextColor()}/></div>
            {children}
        </div>
    )

    return <PageWrapper>
        <Row justify="center" style={{alignItems: 'center', gap: 12, marginTop: 40, marginBottom: 24 }}>
            <IconEmail style={{ fontSize: 32, stroke: getColorAccent1() }}/>
            <Typography.Text
                style={{ fontSize: 20, color: getColorAccent1(), wordBreak: "break-word" }}
                type="success"
                className={"alice-regular"}
            >{t('email_confirmation.email_confirmation')}</Typography.Text>
        </Row>

        <Typography.Text style={{ wordBreak: "break-word" }}>
            {t('email_confirmation.email_confirmed_message')}
        </Typography.Text>
        <Paragraph style={{ wordBreak: "break-word" }}>{t('email_confirmation.description')}</Paragraph>
        <Row style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 24,
            marginTop: 40
        }}>
            <Button
                onClick={handleLoginRedirect}
                size={"large"}
                shape={"round"}
            >
                {t('email_confirmation.go_to_app_button')}
            </Button>
        </Row>
    </PageWrapper>
};